import httpClient from "./httpClient";

class searchService {
    async getFilterFields(channelGuid) {
        return httpClient(`/${channelGuid}/filter-fields`);
    }
}

export default new searchService();